import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["label", "formatPattern", "placeholder", "redaction"];
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Input } from '../Input/Input';
import { InputFormattedPattern } from './InputFormattedPattern';
/**
 * Standard social security number input composing the
 * standard NerdWallet formatted input component.
 *
 * There are some props that we don't allow the consumers
 * to override (like type) on the underlying Formatted (and
 * thus Input) component.
 *
 * `InputSSN` has an opinionated design, and some of those props
 * are not surfaced in `InputSSN.propTypes`.
 */

export var InputSSN = function InputSSN(_ref) {
  var label = _ref.label,
      formatPattern = _ref.formatPattern,
      placeholder = _ref.placeholder,
      redaction = _ref.redaction,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  return /*#__PURE__*/React.createElement(InputFormattedPattern, _extends({}, otherProps, {
    label: label,
    "data-currency": "InputSSN",
    placeholder: "000 - 00 - 0000",
    formatPattern: "999 - 99 - 9999",
    mask: "___ - __ - ____",
    redaction: visible ? '' : '••• - •• - ',
    type: "tel" // render @nerdwallet/react-input
    ,
    component: Input // @nerdwallet/react-input specific props
    ,
    actionLabel: visible ? 'Hide' : 'Show',
    actionProps: {
      onClick: function onClick() {
        return setVisible(function (v) {
          return !v;
        });
      }
    }
  }));
};
InputSSN.propTypes = _objectSpread(_objectSpread({}, Input.propTypes), {}, {
  /**
   * The default label associated with
   * the input field. Should always be supplied
   * to meet accessibility best practices.
   */
  label: PropTypes.string
});
InputSSN.defaultProps = {
  label: 'Social Security number'
};